import React, { Component } from 'react';
import { GraingerAccountContext } from '../../../Context/Context';

import PropTypes from 'prop-types';

import './Banner.scss';
import Belconnen from '../../../Assets/banner-belconnen.jpg'
import Lake from '../../../Assets/banner-lake.jpg'
import Meld from '../../../Assets/banner-meld.jpg'

class Banner extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  getImage() {
    const { name } = this.props;

    switch (name.standard) {
      case 'About Us':     return Belconnen;
      case 'Our Team':     return Lake;
      case 'Our Services': return Meld;
      default:             return null;
    }
  }

  render() {
    const { name } = this.props;
    return (
      <div className='banner-container'>
        <img src={this.getImage()} alt='' className='banner-image' />
        <div className='banner-corner'>
          <div className='banner-corner-text banner-corner-text-large'>{name.standard}</div>
          <div className='banner-corner-text banner-corner-text-small'>{name.small}</div>
        </div>
      </div>
    );
  }
}

Banner.propTypes = {
  name: PropTypes.object.isRequired,
};

Banner.contextType = GraingerAccountContext;
export default Banner;